import { withAuth } from '@utilities/queries';
import { postUploadTransactions } from '@simplywallst/services';
import type { uploadTransactionsResponse } from '@simplywallst/services';
import { useMutation } from '@tanstack/react-query';
import { handleApiError } from '@/utilities/errorHandler';

type Props = {
  onSuccess?: (data: uploadTransactionsResponse | undefined) => void;
  onError?: () => void;
};

export const useUploadTransactions = ({ onSuccess, onError }: Props = {}) =>
  useMutation<uploadTransactionsResponse, Error, File>({
    mutationFn: async (file) => {
      try {
        const response = await withAuth(postUploadTransactions, { file });
        return response.data;
      } catch (unknownError) {
        throw handleApiError(unknownError);
      }
    },
    mutationKey: ['post-ai-import-transactions'],
    onSuccess,
    onError,
  });

export type ImportedTransactions = NonNullable<
  ReturnType<typeof useUploadTransactions>['data']
>;
